import { MenuItem, TextField } from '@mui/material'
import { useFiltros } from '../state/FiltrosContext'

/** Seletor de marca da barra de filtros. '' = todas. */
export function MarcaFilterField({ sx }: { sx?: object }) {
  const { marcaId, setMarcaId, marcas, marcasCarregando, marcasErro } = useFiltros()

  return (
    <TextField
      select
      size="small"
      label="Marca"
      value={marcaId}
      onChange={(e) => setMarcaId(e.target.value)}
      disabled={marcasCarregando || Boolean(marcasErro)}
      title={marcasErro ? `Não foi possível carregar as marcas: ${marcasErro}` : undefined}
      sx={{ minWidth: 180, ...sx }}
    >
      <MenuItem value="">Todas as marcas</MenuItem>
      {marcas.map((m) => (
        <MenuItem key={m.id} value={m.id}>
          {m.nome}
        </MenuItem>
      ))}
    </TextField>
  )
}
